// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';

// import agent from '../../../../assets/services/disaster/allinonebackups1.svg';
// import AP from '../../../../assets/services/disaster/nodisasterrecovery1.svg';
// import HW from '../../../../assets/services/disaster/disasterrecoveryforworlkoads1.svg';
// import self from '../../../../assets/services/disaster/offsitefailover1.svg';
// import efficientStorage from '../../../../assets/services/disaster/seamless1.svg';
// import WO from '../../../../assets/services/disaster/disasterrecoveryrunbooks1.svg';
// import EA from '../../../../assets/services/disaster/automatedtesting1.svg';
// import support from '../../../../assets/services/disaster/support1.svg';

// const Cards = () => {
//   return (
//     <div className="disastercards disastercards-padding my-0 my-md-4">
//       <div className="disastercards-row">
//         <FeatureCard
//           image={agent}
//           title="All-in-one Backup, Disaster Recovery and Protection Services"
//           description={
//             <>
//               As a business you need a cloud backup provider that offers strong security, including encryption, where Synectiks offers all in one solution including high speed disaster recovery.
//               <br />
//               Protect your workloads when disaster strikes, by instantly spinning up systems in our Disaster Recovery Cloud. Adding this service ensures the data is immediately available - and with Synectiks, it's as easy as flipping a switch providing END to END Encryption, In-Flight and Data-At-Rest Encryption, AI-based Ransomware protection.
//             </>
//           }
//         />
//         <FeatureCard image={AP} title="Meet Compliance with minimum complexity" description="Sometimes “where” data is matters. Configure your client DR solutions to deploy to the physical location that delivers the most value in the cloud or the datacenter next door. No need to add, learn, or manage multiple platforms. It’s one solution for all workloads and use cases managed from a single interface that enables you to build a complete DRaaS " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={HW} title="Disaster recovery for physical and virtual workloads" description="Minimize downtime by enabling easy, scalable and efficient cloud-based recovery of all popular workloads including Windows and Linux physical servers and VMs, major hypervisors, and Microsoft apps." />
//         <FeatureCard image={self} title="Production and Automated test failover" description="Ensure quick and easily automated failover of the client’s production environment to an offsite server running in the Acronis Disaster Recovery Storage or to a hot storage in the Cloud. Achieve both RPOs and RTOs shorter than 15 minutes. Save time and effort with a simplified, automated test failover. With the Disaster Recovery service, you can perform scheduled test failovers for any server monthly, giving you the confidence that you can recover quickly and successfully. " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={efficientStorage} title="No-Disaster Recovery Cloud Compute Reservation Cost" description="Pay only when you use the compute resources in the disaster recovery cloud, billed in hourly increments. Pay-as-you-go: pay for used DR cloud storage and for compute only during recovery or tests." />
//         <FeatureCard image={WO} title="Disaster recovery orchestration with runbooks" description="DR orchestration automates and manages disaster recovery processes, using runbooks to define the sequence for spinning up servers, applications, and networks in a cloud recovery site after a failure, ensuring systems come online in the correct order for business continuity, minimizing downtime with fast failover, and allowing non-disruptive testing. It integrates with backups offering flexibility and rapid recovery for complex IT setups. " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={EA} title="Critical data disaster recovery modes" description="Cloud disaster recovery is the most cost-effective and scalable option. Cloud disaster recovery allows you to keep entire virtual environments at the ready, reducing recovery from a disaster or business outage to minutes or even seconds.
// A hybrid cloud disaster recovery method uses a public cloud and private data center (physical or cloud). This provides a great degree of flexibility, keeps costs down, while also meeting any regulatory and compliance needs.
// " />
//         <FeatureCard image={support} title="Support" description="Our team is certified to protect business continuity across your hosted cloud environment—whether it is a mission-critical server, a virtual machine, or an endpoint device. We design and operate cloud backup and disaster recovery plans with multiple recovery options (backup, replication, and rapid restore), supported by built-in cyber protection to reduce the risk of ransomware and data loss. From readiness checks and runbooks to recovery testing and incident support, we ensure your systems can be restored quickly and safely when an outage or disaster occurs." />
//       </div>

//     </div>
//   );
// };

// export default Cards;






import React from 'react';
// import FeatureCard from './FeatureCard'; // Ensure path is correct
import '../../../../styles/disasterCard.css'; // Ensure CSS is imported
import FeatureCard from '../../../../styles/FeatureCard.js';

// Import your images...
import agent from '../../../../assets/services/disaster/allinonebackups1.svg';
import AP from '../../../../assets/services/disaster/nodisasterrecovery1.svg';
import HW from '../../../../assets/services/disaster/disasterrecoveryforworlkoads1.svg';
import self from '../../../../assets/services/disaster/offsitefailover1.svg';
import efficientStorage from '../../../../assets/services/disaster/seamless1.svg';
import WO from '../../../../assets/services/disaster/disasterrecoveryrunbooks1.svg';
import EA from '../../../../assets/services/disaster/automatedtesting1.svg';
import support from '../../../../assets/services/disaster/support1.svg';
import GeoDistributed from '../../../../assets/services/disaster/GeoDistributed.svg';

const Cards = () => {
  const cardData = [
    {
      image: agent,
      title: "All-in-one Backup, Disaster Recovery, and Protection Services",
      description: (
        <>
          <p>
            Businesses need a cloud backup provider that delivers strong security and encryption. Synectiks offers an all‑in‑one solution with high‑speed disaster recovery built in.
          </p>
          <p>
            Protect workloads instantly when disaster strikes by spinning up systems in our Disaster Recovery Cloud. With Synectiks, recovery is as simple as flipping a switch—supported by end‑to‑end encryption (in‑flight and at‑rest), AI‑based ransomware protection, and secure isolation.
          </p>
        </>
      )
    },
    {
      image: AP,
      title: "Meet Compliance with minimum complexity",
      description: (
        <>
          <p>
            Data location matters. Configure client DR deployments to run in the physical location that provides the most value—whether in the cloud or a nearby datacenter.
          </p>
          <p>
            There’s no need to add, learn, or manage multiple platforms. Synectiks provides one solution for all workloads and use cases, managed from a single interface, enabling you to build a complete DRaaS strategy with minimal complexity.
          </p>
        </>
      )
    },
    {
      image: HW,
      title: "Disaster recovery for physical and virtual workloads",
      description: (
        <p>
          Minimize downtime with scalable, efficient cloud‑based recovery for all major workloads, including Windows and Linux physical servers, virtual machines, major hypervisors, and Microsoft applications.
        </p>
      )
    },
    {
      image: self,
      title: "Production and Automated test failover",
      description: (
        <>
          <p>
            Ensure fast, automated failover of production environments to an offsite server running in Acronis Disaster Recovery Storage or to hot cloud storage. Achieve RPOs and RTOs of under 15 minutes.
          </p>
          <p>
            Save time with simplified, automated test failovers. Scheduled test failovers provide confidence in your DR readiness without disrupting production.
          </p>
        </>
      )
    },
    {
      image: efficientStorage,
      title: "No-Disaster Recovery Cloud Compute Reservation Cost",
      description: (
        <p>
          Pay only for the compute resources you use in the disaster recovery cloud, billed in hourly increments. With pay‑as‑you‑go pricing, you pay for DR cloud storage and compute only during recovery or testing.
        </p>
      )
    },
    {
      image: WO,
      title: "Disaster recovery orchestration with runbooks",
      description: (
        <p>
          DR orchestration automates and manages disaster recovery workflows using runbooks that define the sequence for spinning up servers, applications, and networks in a cloud recovery site. This ensures systems come online in the correct order, minimizes downtime, enables non‑disruptive testing, and integrates seamlessly with backups for flexible, rapid recovery across complex IT environments.
        </p>
      )
    },
    {
      image: EA,
      title: "Critical data disaster recovery modes",
      description: (
        <>
          <p>
            Cloud DR is the most cost‑effective and scalable option, allowing entire virtual environments to remain ready for rapid recovery—often in minutes or even seconds.
          </p>
          <p>
            Hybrid DR combines public cloud with private datacenter resources, offering flexibility, cost efficiency, and compliance alignment for regulated industries.
          </p>
        </>
      )
    },

    {
      image: GeoDistributed,
      title: "Geo-Distributed Disaster Recovery Sites",
      description: (
        <>
          <p>
            With Synectiks DR, you can fail over critical workloads to ready‑made cloud recovery sites while adhering to the industry‑leading 3‑2‑1‑1 rule. DR environments run in global datacenters with flexible connectivity and support scheduled test failovers without impacting production.
          </p>
          <p>
            Choose DR site locations based on data sovereignty, latency, and business requirements. Our DR datacenters are designed for high availability with redundant infrastructure, strict physical access controls, and backup power systems (UPS and generators) to maintain operations during power disruptions.
          </p>
        </>
      )
    },
    {
      image: support,
      title: "Support",
      description: (
        <>
          <p>
            At Synectiks, our certified engineers do more than manage backups—we guarantee business continuity. Whether protecting mission‑critical servers, cloud‑native VMs, or remote endpoints, our team provides an end‑to‑end safety net.
          </p>
          <p>
            By combining high‑frequency replication, rapid restoration, and built‑in AI cyber protection, we neutralize ransomware threats and eliminate data‑loss risks. From readiness audits and runbook development to automated recovery testing and 24/7 incident response, we ensure your organization can recover from any disaster quickly, safely, and without data gaps.
          </p>
        </>
      )
    },
  ];

  return (
    <div className="disastercards-section">
      <div className="disastercards-grid">
        {cardData.map((card, index) => (
          <FeatureCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            centered={true} // Forces Center Alignment
          />
        ))}
      </div>
    </div>
  );
};

export default Cards;
